var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-icon',{class:_vm.isSetMarginLeft ? 'support-icon' : 'support-icon-margin-20',attrs:{"name":"info","size":"20px","color":"primary"}},[_c('support-tooltip',{attrs:{"message":_vm.message}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }